var map = {
	"./404.svg": "sEM+",
	"./apple/apple.svg": "EF+K",
	"./axie/axie-claim.svg": "lfgB",
	"./axie/axie-pet.svg": "iaA/",
	"./axie/axie-ronin.svg": "VdOB",
	"./axie/axie.svg": "32ym",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./dashboard2.svg": "OCH/",
	"./dashboard3.svg": "g+Wj",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./glyph/si-glyph-abacus.svg": "8HLU",
	"./glyph/si-glyph-adjustment-horizon.svg": "X48Q",
	"./glyph/si-glyph-adjustment-vertical.svg": "o/3j",
	"./glyph/si-glyph-air-balloon.svg": "rMMx",
	"./glyph/si-glyph-airplane-2.svg": "SWoA",
	"./glyph/si-glyph-airplane.svg": "j7Eg",
	"./glyph/si-glyph-alarm-clock.svg": "8bOw",
	"./glyph/si-glyph-alien.svg": "uPlZ",
	"./glyph/si-glyph-aligh-left.svg": "Br2o",
	"./glyph/si-glyph-align-center.svg": "08Z/",
	"./glyph/si-glyph-align-left.svg": "F9WZ",
	"./glyph/si-glyph-align-right.svg": "IeXu",
	"./glyph/si-glyph-ambulance.svg": "SF8s",
	"./glyph/si-glyph-anchor.svg": "OaR2",
	"./glyph/si-glyph-android.svg": "dGuQ",
	"./glyph/si-glyph-angle-1.svg": "F0HB",
	"./glyph/si-glyph-angle-2.svg": "Mj5q",
	"./glyph/si-glyph-antenna-1.svg": "QDOP",
	"./glyph/si-glyph-apron.svg": "RwyA",
	"./glyph/si-glyph-arrow-backward.svg": "ziEk",
	"./glyph/si-glyph-arrow-change.svg": "fqd8",
	"./glyph/si-glyph-arrow-circle-rycycle.svg": "mHzl",
	"./glyph/si-glyph-arrow-down.svg": "NG3L",
	"./glyph/si-glyph-arrow-forward.svg": "Lca3",
	"./glyph/si-glyph-arrow-four-way.svg": "yknw",
	"./glyph/si-glyph-arrow-fullscreen-2.svg": "fNWs",
	"./glyph/si-glyph-arrow-fullscreen.svg": "cR+P",
	"./glyph/si-glyph-arrow-left-right.svg": "WMNM",
	"./glyph/si-glyph-arrow-left.svg": "EHgY",
	"./glyph/si-glyph-arrow-move.svg": "6V19",
	"./glyph/si-glyph-arrow-reload.svg": "yJdK",
	"./glyph/si-glyph-arrow-resize-1.svg": "iZ7y",
	"./glyph/si-glyph-arrow-resize-2.svg": "o70o",
	"./glyph/si-glyph-arrow-resize-3.svg": "QLAa",
	"./glyph/si-glyph-arrow-resize-4.svg": "6x4Q",
	"./glyph/si-glyph-arrow-resize-5.svg": "SP2/",
	"./glyph/si-glyph-arrow-resize-6.svg": "UWqH",
	"./glyph/si-glyph-arrow-right.svg": "4ZYj",
	"./glyph/si-glyph-arrow-shuffle.svg": "nNk3",
	"./glyph/si-glyph-arrow-thick-down.svg": "dZ/a",
	"./glyph/si-glyph-arrow-thick-left.svg": "lXcE",
	"./glyph/si-glyph-arrow-thick-right.svg": "spV1",
	"./glyph/si-glyph-arrow-thick-thin-down.svg": "GY/o",
	"./glyph/si-glyph-arrow-thick-thin-up.svg": "o25s",
	"./glyph/si-glyph-arrow-thick-up.svg": "aF/J",
	"./glyph/si-glyph-arrow-thin-down.svg": "jvHl",
	"./glyph/si-glyph-arrow-thin-left-bottom.svg": "KXtK",
	"./glyph/si-glyph-arrow-thin-left-top.svg": "D31q",
	"./glyph/si-glyph-arrow-thin-left.svg": "YA+I",
	"./glyph/si-glyph-arrow-thin-right-bottom.svg": "Vai1",
	"./glyph/si-glyph-arrow-thin-right-top.svg": "4cGk",
	"./glyph/si-glyph-arrow-thin-right.svg": "jnWQ",
	"./glyph/si-glyph-arrow-thin-up.svg": "QQxA",
	"./glyph/si-glyph-arrow-three-way-1.svg": "MfJ0",
	"./glyph/si-glyph-arrow-three-way-2.svg": "abuJ",
	"./glyph/si-glyph-arrow-triangle-recycle.svg": "gsey",
	"./glyph/si-glyph-arrow-two-left-right.svg": "MPx1",
	"./glyph/si-glyph-arrow-two-up.svg": "vJD+",
	"./glyph/si-glyph-arrow-two-way-left-right.svg": "3mSG",
	"./glyph/si-glyph-arrow-two-way-right-bottom.svg": "12pb",
	"./glyph/si-glyph-arrow-two-way-right.svg": "hijn",
	"./glyph/si-glyph-arrow-two-way.svg": "lzTk",
	"./glyph/si-glyph-arrow-up-down.svg": "CCfq",
	"./glyph/si-glyph-arrow-up.svg": "ZcFb",
	"./glyph/si-glyph-arrow-wave.svg": "il3Q",
	"./glyph/si-glyph-art-board.svg": "tuE6",
	"./glyph/si-glyph-askterisk.svg": "GK4k",
	"./glyph/si-glyph-atm-card.svg": "bITG",
	"./glyph/si-glyph-axe.svg": "djFU",
	"./glyph/si-glyph-baby-milk-botl.svg": "09y3",
	"./glyph/si-glyph-baby-stroller.svg": "YAmH",
	"./glyph/si-glyph-baby-troller.svg": "GhEo",
	"./glyph/si-glyph-baby.svg": "TEVN",
	"./glyph/si-glyph-back-pack.svg": "k5iE",
	"./glyph/si-glyph-backward-page.svg": "tr3/",
	"./glyph/si-glyph-badge-name.svg": "1gYb",
	"./glyph/si-glyph-bag-plus.svg": "rQVg",
	"./glyph/si-glyph-bag-remove.svg": "/q8Q",
	"./glyph/si-glyph-bag.svg": "4+ji",
	"./glyph/si-glyph-balance.svg": "gj7L",
	"./glyph/si-glyph-balloon.svg": "Llsv",
	"./glyph/si-glyph-bandage.svg": "J2oM",
	"./glyph/si-glyph-bank.svg": "f8G2",
	"./glyph/si-glyph-barcode.svg": "9rkQ",
	"./glyph/si-glyph-barrier.svg": "C7R+",
	"./glyph/si-glyph-baseball-stick.svg": "w54O",
	"./glyph/si-glyph-baseball.svg": "gkkl",
	"./glyph/si-glyph-basket-arrow-down.svg": "SPNr",
	"./glyph/si-glyph-basket-arrow-left.svg": "J8F9",
	"./glyph/si-glyph-basket-arrow-right.svg": "Ysd8",
	"./glyph/si-glyph-basket-arrow-up.svg": "rIO9",
	"./glyph/si-glyph-basket-checked.svg": "17fk",
	"./glyph/si-glyph-basket-error.svg": "66dy",
	"./glyph/si-glyph-basket-plus.svg": "nXOM",
	"./glyph/si-glyph-basket-remove.svg": "kaQh",
	"./glyph/si-glyph-basket.svg": "RXS9",
	"./glyph/si-glyph-basketball.svg": "w8JM",
	"./glyph/si-glyph-battery-charging.svg": "dQpJ",
	"./glyph/si-glyph-battery-empty.svg": "Ne3m",
	"./glyph/si-glyph-battery-full.svg": "yFye",
	"./glyph/si-glyph-battery-half-2.svg": "JUCp",
	"./glyph/si-glyph-battery-half.svg": "1gsF",
	"./glyph/si-glyph-battery-low.svg": "IJ7F",
	"./glyph/si-glyph-bed.svg": "5Ixz",
	"./glyph/si-glyph-bell.svg": "bosh",
	"./glyph/si-glyph-bicycle-1.svg": "zjkd",
	"./glyph/si-glyph-bicycle-3.svg": "x8f6",
	"./glyph/si-glyph-bicycle-man.svg": "rXPx",
	"./glyph/si-glyph-bikini.svg": "vUOb",
	"./glyph/si-glyph-billiard-ball.svg": "BdX0",
	"./glyph/si-glyph-binocular.svg": "Szyv",
	"./glyph/si-glyph-birthday-cake.svg": "O7dq",
	"./glyph/si-glyph-biscuit.svg": "G4sS",
	"./glyph/si-glyph-blender.svg": "oNQV",
	"./glyph/si-glyph-blood-bag.svg": "DLs8",
	"./glyph/si-glyph-bluetooth.svg": "IyHg",
	"./glyph/si-glyph-board.svg": "5qlC",
	"./glyph/si-glyph-boat.svg": "tmjK",
	"./glyph/si-glyph-bolt.svg": "9kTH",
	"./glyph/si-glyph-bomb-1.svg": "/B3/",
	"./glyph/si-glyph-bomb-2.svg": "qt/W",
	"./glyph/si-glyph-bone.svg": "GxQ5",
	"./glyph/si-glyph-book-1.svg": "q6Rm",
	"./glyph/si-glyph-book-3.svg": "sIZI",
	"./glyph/si-glyph-book-4.svg": "eVJV",
	"./glyph/si-glyph-book-@.svg": "vgut",
	"./glyph/si-glyph-book-open.svg": "Xjr9",
	"./glyph/si-glyph-book-person.svg": "EgLr",
	"./glyph/si-glyph-bookcase.svg": "d2m2",
	"./glyph/si-glyph-bookmark.svg": "xkT6",
	"./glyph/si-glyph-botl-2.svg": "v/jO",
	"./glyph/si-glyph-botl-milk.svg": "QkVy",
	"./glyph/si-glyph-bow-tie.svg": "Nyky",
	"./glyph/si-glyph-box-download.svg": "W8WT",
	"./glyph/si-glyph-box-upload.svg": "VPgn",
	"./glyph/si-glyph-box.svg": "VUC1",
	"./glyph/si-glyph-bread.svg": "JT7f",
	"./glyph/si-glyph-briefcase-person.svg": "xLsf",
	"./glyph/si-glyph-briefcase.svg": "u9JE",
	"./glyph/si-glyph-brightness.svg": "wl1S",
	"./glyph/si-glyph-brush-1.svg": "Td0/",
	"./glyph/si-glyph-brush-2.svg": "Pxed",
	"./glyph/si-glyph-brush-and-pencil.svg": "EtYz",
	"./glyph/si-glyph-bubble-chat.svg": "826+",
	"./glyph/si-glyph-bubble-message-dot-2.svg": "nOBk",
	"./glyph/si-glyph-bubble-message-dot.svg": "kkQ0",
	"./glyph/si-glyph-bubble-message-hi.svg": "6K+d",
	"./glyph/si-glyph-bubble-message-quote.svg": "shuh",
	"./glyph/si-glyph-bubble-message-talk.svg": "JolF",
	"./glyph/si-glyph-bubble-message-text.svg": "1nDN",
	"./glyph/si-glyph-bubble-message.svg": "yAEO",
	"./glyph/si-glyph-bucket.svg": "Gku8",
	"./glyph/si-glyph-bug.svg": "/63S",
	"./glyph/si-glyph-building.svg": "bvL1",
	"./glyph/si-glyph-bullet-checked-list.svg": "v7fL",
	"./glyph/si-glyph-bullet-list-2.svg": "m8gh",
	"./glyph/si-glyph-bullet-list.svg": "i/nw",
	"./glyph/si-glyph-bus.svg": "4wTn",
	"./glyph/si-glyph-button-arrow-down.svg": "vfup",
	"./glyph/si-glyph-button-arrow-left.svg": "Fule",
	"./glyph/si-glyph-button-arrow-right.svg": "FtTw",
	"./glyph/si-glyph-button-arrow-up.svg": "qTRk",
	"./glyph/si-glyph-button-buy.svg": "TTGM",
	"./glyph/si-glyph-button-error.svg": "9/49",
	"./glyph/si-glyph-button-hd.svg": "farX",
	"./glyph/si-glyph-button-play.svg": "1gfR",
	"./glyph/si-glyph-button-plus.svg": "21tX",
	"./glyph/si-glyph-button-remove.svg": "yC/K",
	"./glyph/si-glyph-button-sale.svg": "8WPr",
	"./glyph/si-glyph-button-sell.svg": "iWJU",
	"./glyph/si-glyph-button-starburst.svg": "xxhN",
	"./glyph/si-glyph-button-triangle-up.svg": "TAV+",
	"./glyph/si-glyph-button-tv.svg": "D5RR",
	"./glyph/si-glyph-cabin-cable.svg": "XNop",
	"./glyph/si-glyph-cabinet.svg": "+Gxu",
	"./glyph/si-glyph-calculator-2.svg": "F+0+",
	"./glyph/si-glyph-calculator.svg": "biDS",
	"./glyph/si-glyph-calendar-1.svg": "uxVs",
	"./glyph/si-glyph-calendar-3.svg": "aVzr",
	"./glyph/si-glyph-calendar-empty.svg": "l+Ie",
	"./glyph/si-glyph-call-forward.svg": "KS7J",
	"./glyph/si-glyph-call-reply.svg": "0Zux",
	"./glyph/si-glyph-call.svg": "/VOt",
	"./glyph/si-glyph-camera-projector.svg": "cjSa",
	"./glyph/si-glyph-camera-security.svg": "5xmw",
	"./glyph/si-glyph-camera.svg": "afM3",
	"./glyph/si-glyph-can-water.svg": "b2G1",
	"./glyph/si-glyph-candle.svg": "bGR8",
	"./glyph/si-glyph-candy-stick.svg": "mem2",
	"./glyph/si-glyph-candy.svg": "RhGs",
	"./glyph/si-glyph-car-garage.svg": "5W1/",
	"./glyph/si-glyph-car.svg": "a0LW",
	"./glyph/si-glyph-casette.svg": "JVDU",
	"./glyph/si-glyph-cashier-machine.svg": "ssVD",
	"./glyph/si-glyph-castle.svg": "Wb6y",
	"./glyph/si-glyph-caterpillar-machine.svg": "YsOO",
	"./glyph/si-glyph-cente-justify.svg": "UVKX",
	"./glyph/si-glyph-chair-1.svg": "8nEW",
	"./glyph/si-glyph-chair-2.svg": "n2F8",
	"./glyph/si-glyph-champion-cup.svg": "mq+Z",
	"./glyph/si-glyph-chart-column-decrease.svg": "+N7A",
	"./glyph/si-glyph-chart-column-increase.svg": "OVds",
	"./glyph/si-glyph-chart-column.svg": "xwx0",
	"./glyph/si-glyph-chart-decrease.svg": "LPXJ",
	"./glyph/si-glyph-chart-piece.svg": "PSmy",
	"./glyph/si-glyph-checked.svg": "y25J",
	"./glyph/si-glyph-cheese.svg": "Jaik",
	"./glyph/si-glyph-cherry.svg": "oo6Q",
	"./glyph/si-glyph-christmas-mistletoe.svg": "qcfK",
	"./glyph/si-glyph-christmass-ball.svg": "nvph",
	"./glyph/si-glyph-christmass-egg.svg": "kmJ1",
	"./glyph/si-glyph-christmass-hat.svg": "1X/q",
	"./glyph/si-glyph-christmass-tree.svg": "6yyM",
	"./glyph/si-glyph-circle-backward.svg": "IOpU",
	"./glyph/si-glyph-circle-control-pad.svg": "RTUv",
	"./glyph/si-glyph-circle-drashed.svg": "RDJP",
	"./glyph/si-glyph-circle-error.svg": "kclt",
	"./glyph/si-glyph-circle-forward.svg": "N3NA",
	"./glyph/si-glyph-circle-help.svg": "M/IN",
	"./glyph/si-glyph-circle-info.svg": "ptg0",
	"./glyph/si-glyph-circle-load-left.svg": "o7q8",
	"./glyph/si-glyph-circle-load-right.svg": "5Vfo",
	"./glyph/si-glyph-circle-plus.svg": "EksZ",
	"./glyph/si-glyph-circle-remove.svg": "QWee",
	"./glyph/si-glyph-circle-star.svg": "m04t",
	"./glyph/si-glyph-circle-triangle-down.svg": "NUNQ",
	"./glyph/si-glyph-circle-triangle-left.svg": "SNmU",
	"./glyph/si-glyph-circle-triangle-right.svg": "Brj5",
	"./glyph/si-glyph-circle.svg": "IjQy",
	"./glyph/si-glyph-city.svg": "SWlj",
	"./glyph/si-glyph-clamp.svg": "tP2a",
	"./glyph/si-glyph-clapboard-play.svg": "XqCz",
	"./glyph/si-glyph-clapboard.svg": "4e3t",
	"./glyph/si-glyph-clip.svg": "bRPm",
	"./glyph/si-glyph-clipboard-checked.svg": "8JjX",
	"./glyph/si-glyph-clipboard.svg": "pNFN",
	"./glyph/si-glyph-clock.svg": "/On/",
	"./glyph/si-glyph-close.svg": "0Ju9",
	"./glyph/si-glyph-cloud-cloud.svg": "Gb5A",
	"./glyph/si-glyph-cloud-download.svg": "WWSa",
	"./glyph/si-glyph-cloud-heavy-rain.svg": "sNqQ",
	"./glyph/si-glyph-cloud-plus.svg": "Xzrs",
	"./glyph/si-glyph-cloud-rain-heavy-rain.svg": "WY8E",
	"./glyph/si-glyph-cloud-remove.svg": "9unX",
	"./glyph/si-glyph-cloud-snow.svg": "3el/",
	"./glyph/si-glyph-cloud-sun.svg": "O4ax",
	"./glyph/si-glyph-cloud-thunder.svg": "0Hof",
	"./glyph/si-glyph-cloud-upload.svg": "R9Pt",
	"./glyph/si-glyph-cloud.svg": "uWR5",
	"./glyph/si-glyph-clover.svg": "yUb5",
	"./glyph/si-glyph-cock-pot.svg": "VHnt",
	"./glyph/si-glyph-cocktail.svg": "sOLN",
	"./glyph/si-glyph-coconut.svg": "dOiF",
	"./glyph/si-glyph-code.svg": "OQdQ",
	"./glyph/si-glyph-coffee-machine.svg": "XHa1",
	"./glyph/si-glyph-color-picker.svg": "Lo39",
	"./glyph/si-glyph-column-decrease.svg": "/4AE",
	"./glyph/si-glyph-column-increase.svg": "5u6v",
	"./glyph/si-glyph-column-wave.svg": "joi7",
	"./glyph/si-glyph-comb.svg": "n1CQ",
	"./glyph/si-glyph-compass.svg": "w2oq",
	"./glyph/si-glyph-cone.svg": "Q5JQ",
	"./glyph/si-glyph-congratulation-hat.svg": "+fUb",
	"./glyph/si-glyph-connect-1.svg": "DsBJ",
	"./glyph/si-glyph-connect-2.svg": "rXLK",
	"./glyph/si-glyph-contact-book.svg": "4ija",
	"./glyph/si-glyph-contacter.svg": "Htdl",
	"./glyph/si-glyph-contrast.svg": "xxkl",
	"./glyph/si-glyph-control-pad-.svg": "GKXJ",
	"./glyph/si-glyph-corkscrew.svg": "2TVp",
	"./glyph/si-glyph-corner-flag.svg": "M4Bw",
	"./glyph/si-glyph-cover-flow.svg": "I03U",
	"./glyph/si-glyph-cover-food.svg": "g+dy",
	"./glyph/si-glyph-cow.svg": "FMDd",
	"./glyph/si-glyph-cpu.svg": "vQqU",
	"./glyph/si-glyph-cran.svg": "wgi0",
	"./glyph/si-glyph-crop.svg": "P5cP",
	"./glyph/si-glyph-cross-hair-2.svg": "wqDk",
	"./glyph/si-glyph-cross-hair.svg": "x4FS",
	"./glyph/si-glyph-crown.svg": "Fwuk",
	"./glyph/si-glyph-cruise.svg": "QgAM",
	"./glyph/si-glyph-cubic.svg": "cwbX",
	"./glyph/si-glyph-cup-cake.svg": "+SV5",
	"./glyph/si-glyph-curtain.svg": "2eGD",
	"./glyph/si-glyph-customer-support.svg": "I1mB",
	"./glyph/si-glyph-dashboard.svg": "135A",
	"./glyph/si-glyph-data-arrow-down.svg": "+MFc",
	"./glyph/si-glyph-database-download.svg": "zmvZ",
	"./glyph/si-glyph-database-error.svg": "owO3",
	"./glyph/si-glyph-database-plus.svg": "ilX8",
	"./glyph/si-glyph-database-remove.svg": "gp24",
	"./glyph/si-glyph-database-share.svg": "0UMx",
	"./glyph/si-glyph-database-upload.svg": "zehp",
	"./glyph/si-glyph-database.svg": "26cM",
	"./glyph/si-glyph-delete.svg": "Q0x1",
	"./glyph/si-glyph-delicious-circle.svg": "70lE",
	"./glyph/si-glyph-deny.svg": "m5KW",
	"./glyph/si-glyph-desktop.svg": "QGm3",
	"./glyph/si-glyph-dial-number-1.svg": "Csdh",
	"./glyph/si-glyph-dial-number.svg": "y1XM",
	"./glyph/si-glyph-diamond.svg": "TAAt",
	"./glyph/si-glyph-dice-1.svg": "SWVy",
	"./glyph/si-glyph-dice-2.svg": "sA6H",
	"./glyph/si-glyph-dice-3.svg": "SbQc",
	"./glyph/si-glyph-dice-5.svg": "apVc",
	"./glyph/si-glyph-dice-6-.svg": "RqLi",
	"./glyph/si-glyph-dice-6.svg": "97WR",
	"./glyph/si-glyph-disc-add.svg": "HfJ9",
	"./glyph/si-glyph-disc-deny.svg": "pmzC",
	"./glyph/si-glyph-disc-download.svg": "SgnT",
	"./glyph/si-glyph-disc-error.svg": "jwlJ",
	"./glyph/si-glyph-disc-pause.svg": "6mUl",
	"./glyph/si-glyph-disc-play-2.svg": "523r",
	"./glyph/si-glyph-disc-play.svg": "pGls",
	"./glyph/si-glyph-disc-remove.svg": "WUSZ",
	"./glyph/si-glyph-disc-stop.svg": "4o0J",
	"./glyph/si-glyph-disc-upload.svg": "rz6C",
	"./glyph/si-glyph-disc.svg": "LKx0",
	"./glyph/si-glyph-dish.svg": "21nC",
	"./glyph/si-glyph-disk-antenna.svg": "twII",
	"./glyph/si-glyph-dna.svg": "hHVR",
	"./glyph/si-glyph-document-arrow-down.svg": "Ygnn",
	"./glyph/si-glyph-document-arrow-left.svg": "GKSt",
	"./glyph/si-glyph-document-arrow-right.svg": "t4N1",
	"./glyph/si-glyph-document-arrow-up.svg": "posm",
	"./glyph/si-glyph-document-backward.svg": "EQp7",
	"./glyph/si-glyph-document-bullet-list.svg": "GZTO",
	"./glyph/si-glyph-document-checked.svg": "jdcq",
	"./glyph/si-glyph-document-copy.svg": "50ND",
	"./glyph/si-glyph-document-doc.svg": "I0mF",
	"./glyph/si-glyph-document-edit.svg": "Ekvj",
	"./glyph/si-glyph-document-error.svg": "pAFk",
	"./glyph/si-glyph-document-forward.svg": "CxgS",
	"./glyph/si-glyph-document-help.svg": "iq0O",
	"./glyph/si-glyph-document-music.svg": "MWgf",
	"./glyph/si-glyph-document-pdf.svg": "zLGM",
	"./glyph/si-glyph-document-plus.svg": "6tom",
	"./glyph/si-glyph-document-remove.svg": "cpVh",
	"./glyph/si-glyph-document-rss.svg": "2Ecb",
	"./glyph/si-glyph-document-search.svg": "8KX/",
	"./glyph/si-glyph-document-star.svg": "hABC",
	"./glyph/si-glyph-document-warning.svg": "ZoBt",
	"./glyph/si-glyph-document.svg": "Q6PY",
	"./glyph/si-glyph-dog.svg": "8vmh",
	"./glyph/si-glyph-door.svg": "D90o",
	"./glyph/si-glyph-downstair.svg": "JGYT",
	"./glyph/si-glyph-downwards-arrow-to-bar.svg": "se1n",
	"./glyph/si-glyph-drill.svg": "An4+",
	"./glyph/si-glyph-drop-water.svg": "3NY/",
	"./glyph/si-glyph-dropbox.svg": "zc/n",
	"./glyph/si-glyph-drum.svg": "Z0L+",
	"./glyph/si-glyph-easal.svg": "hIO3",
	"./glyph/si-glyph-edit.svg": "P4x1",
	"./glyph/si-glyph-egg.svg": "y2KZ",
	"./glyph/si-glyph-eject.svg": "vuuD",
	"./glyph/si-glyph-electron.svg": "VaA1",
	"./glyph/si-glyph-elevator-down.svg": "vtLf",
	"./glyph/si-glyph-elevator-up.svg": "XgSz",
	"./glyph/si-glyph-emoticon.svg": "GyHu",
	"./glyph/si-glyph-end-page.svg": "utMX",
	"./glyph/si-glyph-erase.svg": "6tm7",
	"./glyph/si-glyph-euro.svg": "t9js",
	"./glyph/si-glyph-excavator.svg": "PjHh",
	"./glyph/si-glyph-extinguisher.svg": "V2nJ",
	"./glyph/si-glyph-eye-drop.svg": "5wxl",
	"./glyph/si-glyph-eye-glass.svg": "WZ4o",
	"./glyph/si-glyph-factory.svg": "yMm3",
	"./glyph/si-glyph-faucet.svg": "omus",
	"./glyph/si-glyph-feather.svg": "kMlh",
	"./glyph/si-glyph-female.svg": "mhFg",
	"./glyph/si-glyph-fence-2.svg": "KjR9",
	"./glyph/si-glyph-fence.svg": "9tlV",
	"./glyph/si-glyph-file-box.svg": "2/i0",
	"./glyph/si-glyph-file-download.svg": "/jgC",
	"./glyph/si-glyph-file-upload.svg": "cro5",
	"./glyph/si-glyph-film-35mm.svg": "rpZT",
	"./glyph/si-glyph-film.svg": "0Z+z",
	"./glyph/si-glyph-finder.svg": "rmZl",
	"./glyph/si-glyph-finger-up.svg": "x6Py",
	"./glyph/si-glyph-fire-alarm.svg": "XRf0",
	"./glyph/si-glyph-fire-hydrant.svg": "LI8z",
	"./glyph/si-glyph-fire-wood.svg": "6G8w",
	"./glyph/si-glyph-fire.svg": "Oymh",
	"./glyph/si-glyph-first-aid-briefcase.svg": "Xg+k",
	"./glyph/si-glyph-fish.svg": "ptNi",
	"./glyph/si-glyph-flag.svg": "fdmO",
	"./glyph/si-glyph-float.svg": "KTdJ",
	"./glyph/si-glyph-floppy-disk.svg": "3tC7",
	"./glyph/si-glyph-flower-pot.svg": "rbZW",
	"./glyph/si-glyph-flower.svg": "fVmJ",
	"./glyph/si-glyph-folder-contact.svg": "BT2N",
	"./glyph/si-glyph-folder-error.svg": "c9iZ",
	"./glyph/si-glyph-folder-music.svg": "M9Ua",
	"./glyph/si-glyph-folder-open.svg": "/2RC",
	"./glyph/si-glyph-folder-plus.svg": "G9ck",
	"./glyph/si-glyph-folder-remove.svg": "vRNT",
	"./glyph/si-glyph-folder-rss.svg": "cut4",
	"./glyph/si-glyph-folder-search.svg": "ppw+",
	"./glyph/si-glyph-folder-share.svg": "4bG3",
	"./glyph/si-glyph-folder-warning.svg": "Z+u/",
	"./glyph/si-glyph-folder.svg": "qGB+",
	"./glyph/si-glyph-foot-sign.svg": "7sip",
	"./glyph/si-glyph-forcus.svg": "PVEf",
	"./glyph/si-glyph-forklift.svg": "0xYA",
	"./glyph/si-glyph-forward-page.svg": "MiWu",
	"./glyph/si-glyph-fridge.svg": "h8+d",
	"./glyph/si-glyph-fullscreen.svg": "Y+ji",
	"./glyph/si-glyph-game-1.svg": "cJNv",
	"./glyph/si-glyph-game-controll.svg": "INxu",
	"./glyph/si-glyph-gas-station.svg": "A5wq",
	"./glyph/si-glyph-gate.svg": "CGiV",
	"./glyph/si-glyph-gear-1.svg": "dqot",
	"./glyph/si-glyph-gear.svg": "ao4p",
	"./glyph/si-glyph-ghost.svg": "DXdQ",
	"./glyph/si-glyph-gift.svg": "ABEe",
	"./glyph/si-glyph-glass-water.svg": "3t1d",
	"./glyph/si-glyph-global.svg": "5ZaK",
	"./glyph/si-glyph-globe.svg": "6Acg",
	"./glyph/si-glyph-glove.svg": "8Vj8",
	"./glyph/si-glyph-golf-ball.svg": "9OJ7",
	"./glyph/si-glyph-golf-flag.svg": "MIXO",
	"./glyph/si-glyph-guitar.svg": "aS22",
	"./glyph/si-glyph-hamburger.svg": "LIEF",
	"./glyph/si-glyph-hammer-and-wrench.svg": "dOUY",
	"./glyph/si-glyph-hammer.svg": "Zjmq",
	"./glyph/si-glyph-hand-lamp.svg": "hoql",
	"./glyph/si-glyph-hand-switch.svg": "Tlah",
	"./glyph/si-glyph-hand.svg": "GTFF",
	"./glyph/si-glyph-handcuff.svg": "DZfz",
	"./glyph/si-glyph-hanger.svg": "Cbte",
	"./glyph/si-glyph-hardware.svg": "fi/y",
	"./glyph/si-glyph-hat-chef.svg": "qQc/",
	"./glyph/si-glyph-hat.svg": "RuFN",
	"./glyph/si-glyph-head-set.svg": "+hbG",
	"./glyph/si-glyph-head.svg": "cHxl",
	"./glyph/si-glyph-heart-delete.svg": "2r7v",
	"./glyph/si-glyph-heart-plus.svg": "VmNM",
	"./glyph/si-glyph-heart-remove.svg": "lEpL",
	"./glyph/si-glyph-heart-signal.svg": "bm0V",
	"./glyph/si-glyph-heart.svg": "A+Op",
	"./glyph/si-glyph-helicopter-pad.svg": "I8b3",
	"./glyph/si-glyph-helicopter.svg": "sLvF",
	"./glyph/si-glyph-helm-wheel.svg": "uArx",
	"./glyph/si-glyph-helmet.svg": "ieNy",
	"./glyph/si-glyph-hightheel.svg": "L0v3",
	"./glyph/si-glyph-history.svg": "g3ez",
	"./glyph/si-glyph-hockey.svg": "GpN6",
	"./glyph/si-glyph-home-page.svg": "qH5c",
	"./glyph/si-glyph-horse-shoe.svg": "ZDpu",
	"./glyph/si-glyph-horse.svg": "YcA4",
	"./glyph/si-glyph-hospital.svg": "8I13",
	"./glyph/si-glyph-house.svg": "4vvl",
	"./glyph/si-glyph-ice-cream.svg": "51g1",
	"./glyph/si-glyph-id-badge.svg": "6Cae",
	"./glyph/si-glyph-image.svg": "71eI",
	"./glyph/si-glyph-in-columns.svg": "BDc5",
	"./glyph/si-glyph-inbox-download.svg": "mOAD",
	"./glyph/si-glyph-inbox-upload.svg": "I7pN",
	"./glyph/si-glyph-infinity-2.svg": "FYUZ",
	"./glyph/si-glyph-infinity.svg": "KIlG",
	"./glyph/si-glyph-info.svg": "FyQQ",
	"./glyph/si-glyph-ipod.svg": "d2YY",
	"./glyph/si-glyph-iron.svg": "HLOP",
	"./glyph/si-glyph-jump-backward.svg": "NvMd",
	"./glyph/si-glyph-jump-double-page-left-right.svg": "vGiC",
	"./glyph/si-glyph-jump-forward.svg": "evkw",
	"./glyph/si-glyph-jump-page-left-right.svg": "eXJ5",
	"./glyph/si-glyph-jump-page-up-down.svg": "tVXn",
	"./glyph/si-glyph-kette.svg": "AzFn",
	"./glyph/si-glyph-key-2.svg": "iQJI",
	"./glyph/si-glyph-key.svg": "yt3U",
	"./glyph/si-glyph-keyboard.svg": "FKir",
	"./glyph/si-glyph-knife.svg": "lbcJ",
	"./glyph/si-glyph-ladder-pool.svg": "DE1W",
	"./glyph/si-glyph-lamp-desk.svg": "ZX4G",
	"./glyph/si-glyph-lamp.svg": "mGea",
	"./glyph/si-glyph-lavabo.svg": "pH6K",
	"./glyph/si-glyph-law-hammer.svg": "dNha",
	"./glyph/si-glyph-layout-1.svg": "PBQO",
	"./glyph/si-glyph-layout-2.svg": "66yN",
	"./glyph/si-glyph-layout-3.svg": "wZ5t",
	"./glyph/si-glyph-layout-4.svg": "o9ea",
	"./glyph/si-glyph-leaf.svg": "v6iQ",
	"./glyph/si-glyph-left-justify.svg": "cLXk",
	"./glyph/si-glyph-leftwards-arrow-to-bar.svg": "3nys",
	"./glyph/si-glyph-light-alarm.svg": "R62b",
	"./glyph/si-glyph-light-bulb.svg": "2+Qu",
	"./glyph/si-glyph-light-house.svg": "1K2N",
	"./glyph/si-glyph-like-unlike.svg": "TDi6",
	"./glyph/si-glyph-like.svg": "V8wk",
	"./glyph/si-glyph-line-two-angle-point.svg": "B6JB",
	"./glyph/si-glyph-link-1.svg": "Jmpc",
	"./glyph/si-glyph-link-2.svg": "f6ux",
	"./glyph/si-glyph-link-3.svg": "a26K",
	"./glyph/si-glyph-load.svg": "JuA3",
	"./glyph/si-glyph-lock-unlock.svg": "QEF6",
	"./glyph/si-glyph-lock.svg": "YXCl",
	"./glyph/si-glyph-louder-2.svg": "KRqT",
	"./glyph/si-glyph-louder-speaker.svg": "kFfR",
	"./glyph/si-glyph-magnet.svg": "9Ujw",
	"./glyph/si-glyph-magnifier-2.svg": "jhwb",
	"./glyph/si-glyph-magnifier.svg": "OOy9",
	"./glyph/si-glyph-mail-box.svg": "Iynn",
	"./glyph/si-glyph-mail-empty.svg": "3Mss",
	"./glyph/si-glyph-mail-has-mail.svg": "FJc5",
	"./glyph/si-glyph-mail-inbox.svg": "qrBs",
	"./glyph/si-glyph-mail-send.svg": "FQPI",
	"./glyph/si-glyph-mail.svg": "xNGc",
	"./glyph/si-glyph-male.svg": "ZGus",
	"./glyph/si-glyph-man-doctor.svg": "6W1r",
	"./glyph/si-glyph-map-3.svg": "CCew",
	"./glyph/si-glyph-map-square.svg": "u5f5",
	"./glyph/si-glyph-mark-snorker.svg": "vOh5",
	"./glyph/si-glyph-mask-1.svg": "SGAS",
	"./glyph/si-glyph-mask-2.svg": "ts5B",
	"./glyph/si-glyph-medal-star.svg": "JM37",
	"./glyph/si-glyph-microphone-1.svg": "MZVR",
	"./glyph/si-glyph-microphone-2.svg": "MDFq",
	"./glyph/si-glyph-microscope.svg": "vFlL",
	"./glyph/si-glyph-mobile.svg": "qWVb",
	"./glyph/si-glyph-mocule.svg": "5vFx",
	"./glyph/si-glyph-money-$.svg": "ow2v",
	"./glyph/si-glyph-money-3.svg": "Jn2V",
	"./glyph/si-glyph-money-bag.svg": "rGij",
	"./glyph/si-glyph-money-coin.svg": "Y0TV",
	"./glyph/si-glyph-moon-star.svg": "MiJf",
	"./glyph/si-glyph-motobike.svg": "W79q",
	"./glyph/si-glyph-mountain.svg": "GdnE",
	"./glyph/si-glyph-movie-play.svg": "FAyX",
	"./glyph/si-glyph-movie-projector.svg": "bVar",
	"./glyph/si-glyph-multifunction-knife.svg": "Eq1l",
	"./glyph/si-glyph-mushrooms.svg": "dAjy",
	"./glyph/si-glyph-music-note.svg": "979U",
	"./glyph/si-glyph-music.svg": "Hedw",
	"./glyph/si-glyph-mustache.svg": "r1ht",
	"./glyph/si-glyph-network-2.svg": "qrxj",
	"./glyph/si-glyph-network.svg": "GU0D",
	"./glyph/si-glyph-newspaper.svg": "8bKc",
	"./glyph/si-glyph-no-dog.svg": "t8+e",
	"./glyph/si-glyph-no-smoke.svg": "LGIj",
	"./glyph/si-glyph-note-2.svg": "PDeT",
	"./glyph/si-glyph-note.svg": "IUEC",
	"./glyph/si-glyph-old-phone.svg": "/e/J",
	"./glyph/si-glyph-open.svg": "yS+n",
	"./glyph/si-glyph-pallette.svg": "Mxg9",
	"./glyph/si-glyph-paper-clip.svg": "sHQA",
	"./glyph/si-glyph-paper-plane.svg": "4zy3",
	"./glyph/si-glyph-paper-roll.svg": "hcjt",
	"./glyph/si-glyph-paper-shredder.svg": "0OpJ",
	"./glyph/si-glyph-pause.svg": "GEE+",
	"./glyph/si-glyph-pawn.svg": "MWzt",
	"./glyph/si-glyph-paypal.svg": "KPU1",
	"./glyph/si-glyph-pen-nib.svg": "pgge",
	"./glyph/si-glyph-pen.svg": "RjsU",
	"./glyph/si-glyph-pencil.svg": "fiCc",
	"./glyph/si-glyph-percent.svg": "FBYO",
	"./glyph/si-glyph-person-2.svg": "nIEe",
	"./glyph/si-glyph-person-checked.svg": "ODa0",
	"./glyph/si-glyph-person-door-man.svg": "SrKW",
	"./glyph/si-glyph-person-error.svg": "lc5Y",
	"./glyph/si-glyph-person-man.svg": "cmG9",
	"./glyph/si-glyph-person-people.svg": "sJC1",
	"./glyph/si-glyph-person-plus.svg": "eriz",
	"./glyph/si-glyph-person-prison.svg": "HuQ/",
	"./glyph/si-glyph-person-public.svg": "S3Rt",
	"./glyph/si-glyph-person-remove.svg": "Mzv8",
	"./glyph/si-glyph-person-talk.svg": "bRl4",
	"./glyph/si-glyph-person-woman.svg": "rwto",
	"./glyph/si-glyph-person.svg": "gVLs",
	"./glyph/si-glyph-pet-carrier.svg": "lUQz",
	"./glyph/si-glyph-phone-fax.svg": "JSBq",
	"./glyph/si-glyph-phone-number.svg": "NaKu",
	"./glyph/si-glyph-piano.svg": "L1La",
	"./glyph/si-glyph-pick.svg": "V76k",
	"./glyph/si-glyph-picture-2.svg": "rd4W",
	"./glyph/si-glyph-picture-copy.svg": "XZ2g",
	"./glyph/si-glyph-picture.svg": "1R7o",
	"./glyph/si-glyph-piggy-bank.svg": "BjZX",
	"./glyph/si-glyph-pill.svg": "wvkr",
	"./glyph/si-glyph-pin-location-1.svg": "e8mn",
	"./glyph/si-glyph-pin-location-2.svg": "gFNP",
	"./glyph/si-glyph-pin-location-add.svg": "9xQg",
	"./glyph/si-glyph-pin-location-delete.svg": "T6vV",
	"./glyph/si-glyph-pin-location-love.svg": "BIOq",
	"./glyph/si-glyph-pin-location-map.svg": "nJ8H",
	"./glyph/si-glyph-pin-location-remove.svg": "2spi",
	"./glyph/si-glyph-pin-location.svg": "GY41",
	"./glyph/si-glyph-pin-map.svg": "QZly",
	"./glyph/si-glyph-ping-pong-racket.svg": "oPWh",
	"./glyph/si-glyph-pipe.svg": "awA8",
	"./glyph/si-glyph-pizza.svg": "i0Mr",
	"./glyph/si-glyph-plugin.svg": "l1pX",
	"./glyph/si-glyph-plus.svg": "S+xJ",
	"./glyph/si-glyph-podium.svg": "6a67",
	"./glyph/si-glyph-poker-1.svg": "MJWw",
	"./glyph/si-glyph-poker-2.svg": "vKHc",
	"./glyph/si-glyph-poker-3.svg": "mIe1",
	"./glyph/si-glyph-poker-4.svg": "stQq",
	"./glyph/si-glyph-print.svg": "1XKp",
	"./glyph/si-glyph-puzzle.svg": "VYKj",
	"./glyph/si-glyph-quote-close.svg": "EUph",
	"./glyph/si-glyph-quote-open.svg": "n43c",
	"./glyph/si-glyph-radio.svg": "GrGB",
	"./glyph/si-glyph-radioactive.svg": "JaPB",
	"./glyph/si-glyph-record.svg": "U7dB",
	"./glyph/si-glyph-reduce.svg": "cBTy",
	"./glyph/si-glyph-reel-audio.svg": "LB9O",
	"./glyph/si-glyph-reel-film.svg": "F1ZY",
	"./glyph/si-glyph-remove.svg": "DNQn",
	"./glyph/si-glyph-repeat.svg": "OHnW",
	"./glyph/si-glyph-resize-in-frame.svg": "WNnj",
	"./glyph/si-glyph-resize-out-frame.svg": "PxWN",
	"./glyph/si-glyph-retroeexcavadora.svg": "euYf",
	"./glyph/si-glyph-ribbon.svg": "fd5M",
	"./glyph/si-glyph-right-justify.svg": "PoBW",
	"./glyph/si-glyph-rightwards-arrow-to-bar.svg": "Q2i4",
	"./glyph/si-glyph-ring.svg": "bKSA",
	"./glyph/si-glyph-road.svg": "1F/d",
	"./glyph/si-glyph-rocket.svg": "BTDS",
	"./glyph/si-glyph-roller.svg": "yf6d",
	"./glyph/si-glyph-rss.svg": "bvIe",
	"./glyph/si-glyph-rugby-ball.svg": "Kq3y",
	"./glyph/si-glyph-ruler.svg": "G6lP",
	"./glyph/si-glyph-safe-box.svg": "2JAK",
	"./glyph/si-glyph-safe-pin.svg": "uTgM",
	"./glyph/si-glyph-satellite.svg": "tF3J",
	"./glyph/si-glyph-saw.svg": "9VzY",
	"./glyph/si-glyph-scissor-line-cut.svg": "NfwB",
	"./glyph/si-glyph-scissor.svg": "CFee",
	"./glyph/si-glyph-screen-ful.svg": "dgwh",
	"./glyph/si-glyph-screen-scale.svg": "UZhY",
	"./glyph/si-glyph-screw-driver.svg": "nava",
	"./glyph/si-glyph-screw.svg": "qLTR",
	"./glyph/si-glyph-sd-card.svg": "VJss",
	"./glyph/si-glyph-seriff.svg": "Trkk",
	"./glyph/si-glyph-sewing-machine.svg": "36dW",
	"./glyph/si-glyph-sewing-roll.svg": "VPk6",
	"./glyph/si-glyph-share-1.svg": "9cbk",
	"./glyph/si-glyph-share-2.svg": "N0qK",
	"./glyph/si-glyph-share-3.svg": "mQRb",
	"./glyph/si-glyph-share-5.svg": "1t9Y",
	"./glyph/si-glyph-sheep.svg": "pB3k",
	"./glyph/si-glyph-shield-2.svg": "pf8E",
	"./glyph/si-glyph-shield-plus.svg": "g6SY",
	"./glyph/si-glyph-shield-star.svg": "phee",
	"./glyph/si-glyph-shield.svg": "OLWR",
	"./glyph/si-glyph-shovel.svg": "/d6A",
	"./glyph/si-glyph-shower.svg": "mmnM",
	"./glyph/si-glyph-sign-board.svg": "It7R",
	"./glyph/si-glyph-sign-foot.svg": "iJsE",
	"./glyph/si-glyph-sign-in.svg": "FBWj",
	"./glyph/si-glyph-sign-out.svg": "z2b/",
	"./glyph/si-glyph-sign-p.svg": "axpd",
	"./glyph/si-glyph-sign-road-1.svg": "E476",
	"./glyph/si-glyph-sign-road-2.svg": "nXXn",
	"./glyph/si-glyph-signal-1.svg": "ILpc",
	"./glyph/si-glyph-signal-2.svg": "payK",
	"./glyph/si-glyph-signal-3.svg": "P6/p",
	"./glyph/si-glyph-site-map-revert.svg": "Ij8A",
	"./glyph/si-glyph-site-map.svg": "Rwx8",
	"./glyph/si-glyph-skateboard.svg": "zott",
	"./glyph/si-glyph-skull.svg": "pkch",
	"./glyph/si-glyph-sleep.svg": "6lmK",
	"./glyph/si-glyph-slide-show.svg": "POBr",
	"./glyph/si-glyph-smartphone.svg": "0wft",
	"./glyph/si-glyph-sms.svg": "xJXp",
	"./glyph/si-glyph-snow.svg": "p7Mh",
	"./glyph/si-glyph-soccer-yard.svg": "bRzS",
	"./glyph/si-glyph-sock.svg": "vggI",
	"./glyph/si-glyph-socket.svg": "beNj",
	"./glyph/si-glyph-solar-blind.svg": "j75C",
	"./glyph/si-glyph-sos.svg": "NPdK",
	"./glyph/si-glyph-sound-mute.svg": "eBvw",
	"./glyph/si-glyph-sound.svg": "Cwcu",
	"./glyph/si-glyph-space-ship.svg": "rE3/",
	"./glyph/si-glyph-spanner.svg": "+lVj",
	"./glyph/si-glyph-spoon-fork.svg": "IIwL",
	"./glyph/si-glyph-spray.svg": "Hutv",
	"./glyph/si-glyph-square-checked.svg": "Cr/4",
	"./glyph/si-glyph-square-dashed-1.svg": "nQRS",
	"./glyph/si-glyph-square-dashed-2.svg": "GOXB",
	"./glyph/si-glyph-square-delicious.svg": "G6+Y",
	"./glyph/si-glyph-square-eight-angle-point.svg": "3waf",
	"./glyph/si-glyph-square-four-angle-point.svg": "9ImW",
	"./glyph/si-glyph-square-four.svg": "HbJC",
	"./glyph/si-glyph-square-plus.svg": "Ykmc",
	"./glyph/si-glyph-square-star.svg": "KFM/",
	"./glyph/si-glyph-square.svg": "4Pg0",
	"./glyph/si-glyph-stamps.svg": "hVrC",
	"./glyph/si-glyph-star-cross.svg": "er86",
	"./glyph/si-glyph-star-stick.svg": "XIYz",
	"./glyph/si-glyph-stele.svg": "R2ZH",
	"./glyph/si-glyph-stelescope.svg": "gXG2",
	"./glyph/si-glyph-stereo-jack.svg": "wyPV",
	"./glyph/si-glyph-stethoscope.svg": "ivwU",
	"./glyph/si-glyph-store.svg": "GFDV",
	"./glyph/si-glyph-stove.svg": "SUc6",
	"./glyph/si-glyph-strawberry.svg": "6t12",
	"./glyph/si-glyph-street-2.svg": "IgMs",
	"./glyph/si-glyph-strolley-arrow-down.svg": "GprO",
	"./glyph/si-glyph-strolley-arrow-up.svg": "7Crk",
	"./glyph/si-glyph-strolley-plus.svg": "h+x7",
	"./glyph/si-glyph-strolley-remove.svg": "2ak1",
	"./glyph/si-glyph-strolley.svg": "NhtX",
	"./glyph/si-glyph-subway.svg": "yKII",
	"./glyph/si-glyph-suitcase-person.svg": "RE/O",
	"./glyph/si-glyph-suitcase.svg": "4XtG",
	"./glyph/si-glyph-syringe.svg": "HUMM",
	"./glyph/si-glyph-t-shirt.svg": "oUcO",
	"./glyph/si-glyph-tablet.svg": "zjbM",
	"./glyph/si-glyph-tag-1.svg": "H/Gb",
	"./glyph/si-glyph-tag-one-plus.svg": "7Bog",
	"./glyph/si-glyph-tag-price.svg": "vTEU",
	"./glyph/si-glyph-tag.svg": "EWdw",
	"./glyph/si-glyph-tank.svg": "Sbxe",
	"./glyph/si-glyph-targer.svg": "Yz11",
	"./glyph/si-glyph-tea-cup.svg": "iO71",
	"./glyph/si-glyph-teeth.svg": "/hdn",
	"./glyph/si-glyph-telephone-box.svg": "BGVC",
	"./glyph/si-glyph-telescope.svg": "J7+P",
	"./glyph/si-glyph-television.svg": "fwo+",
	"./glyph/si-glyph-tennis-racket-ball.svg": "jg0w",
	"./glyph/si-glyph-tent-1.svg": "sVQC",
	"./glyph/si-glyph-tent-camp.svg": "3JU5",
	"./glyph/si-glyph-test-tube-2.svg": "kpoC",
	"./glyph/si-glyph-test-tube-empty.svg": "+eRx",
	"./glyph/si-glyph-test-tube.svg": "E59t",
	"./glyph/si-glyph-text-search.svg": "v9tP",
	"./glyph/si-glyph-thermometer.svg": "ZKeI",
	"./glyph/si-glyph-three-ball.svg": "Jfu4",
	"./glyph/si-glyph-tic-tac-toe.svg": "aq0P",
	"./glyph/si-glyph-time-glass.svg": "1jPI",
	"./glyph/si-glyph-time-reload.svg": "nT2h",
	"./glyph/si-glyph-timer.svg": "/JAC",
	"./glyph/si-glyph-toilet.svg": "atxO",
	"./glyph/si-glyph-tool-box.svg": "0rpi",
	"./glyph/si-glyph-traffic-light.svg": "znjx",
	"./glyph/si-glyph-train-rail.svg": "iB8q",
	"./glyph/si-glyph-train.svg": "HSiE",
	"./glyph/si-glyph-trash.svg": "SOfJ",
	"./glyph/si-glyph-tree.svg": "QZMl",
	"./glyph/si-glyph-trees.svg": "G/ML",
	"./glyph/si-glyph-triangle-double-arrow-down.svg": "yksp",
	"./glyph/si-glyph-triangle-double-arrow-left.svg": "NZsk",
	"./glyph/si-glyph-triangle-double-arrow-right.svg": "X6nt",
	"./glyph/si-glyph-triangle-double-arrow-up.svg": "VOJJ",
	"./glyph/si-glyph-triangle-down.svg": "drNo",
	"./glyph/si-glyph-triangle-left.svg": "ux7I",
	"./glyph/si-glyph-triangle-right.svg": "WrKP",
	"./glyph/si-glyph-triangle-up.svg": "h2Cb",
	"./glyph/si-glyph-trolley-2.svg": "CgDt",
	"./glyph/si-glyph-trolley-arrow-down.svg": "gCXH",
	"./glyph/si-glyph-trolley-arrow-up.svg": "KP2/",
	"./glyph/si-glyph-trolley-briefcase.svg": "fRIJ",
	"./glyph/si-glyph-trolley-error.svg": "UwjG",
	"./glyph/si-glyph-trolley-full.svg": "Nhi+",
	"./glyph/si-glyph-trolley-plus.svg": "bY9v",
	"./glyph/si-glyph-trolley-remove.svg": "SEGI",
	"./glyph/si-glyph-truck.svg": "7ebH",
	"./glyph/si-glyph-trumpet.svg": "bL7l",
	"./glyph/si-glyph-turn-off.svg": "0+6f",
	"./glyph/si-glyph-two-arrow-down.svg": "RQLV",
	"./glyph/si-glyph-two-arrow-in-down-up.svg": "z/Cm",
	"./glyph/si-glyph-two-arrow-in-left-right.svg": "n08D",
	"./glyph/si-glyph-two-arrow-left.svg": "wqXF",
	"./glyph/si-glyph-two-arrow-right.svg": "7JY8",
	"./glyph/si-glyph-typewriter.svg": "bBjX",
	"./glyph/si-glyph-umberlla-chair.svg": "fAfA",
	"./glyph/si-glyph-umbrella-close.svg": "Vgu+",
	"./glyph/si-glyph-umbrella-open.svg": "PfDE",
	"./glyph/si-glyph-umbrella-sea.svg": "ai1L",
	"./glyph/si-glyph-upstair.svg": "rgmi",
	"./glyph/si-glyph-upwards-arrow-to-bar.svg": "QRkw",
	"./glyph/si-glyph-upwards-arrow-with-loop.svg": "S4Dr",
	"./glyph/si-glyph-usb.svg": "E0Hp",
	"./glyph/si-glyph-view.svg": "Ti/J",
	"./glyph/si-glyph-wacom-tablet.svg": "g1I/",
	"./glyph/si-glyph-wall.svg": "ZddQ",
	"./glyph/si-glyph-wallet.svg": "ikak",
	"./glyph/si-glyph-wash-machine-2.svg": "C5qG",
	"./glyph/si-glyph-wash-machine.svg": "f7UC",
	"./glyph/si-glyph-watch.svg": "uB2D",
	"./glyph/si-glyph-webcam.svg": "93/n",
	"./glyph/si-glyph-weight-down.svg": "yEkA",
	"./glyph/si-glyph-weight-kilograms.svg": "nnt2",
	"./glyph/si-glyph-weight-up.svg": "Lnjq",
	"./glyph/si-glyph-wheel-chair.svg": "pCXh",
	"./glyph/si-glyph-wheel-steel.svg": "CJ2e",
	"./glyph/si-glyph-wieght.svg": "aHam",
	"./glyph/si-glyph-wifi-1.svg": "4PEa",
	"./glyph/si-glyph-wind-turbines.svg": "Wh89",
	"./glyph/si-glyph-window.svg": "P2Er",
	"./glyph/si-glyph-wood-stove.svg": "aTeG",
	"./glyph/si-glyph-wrench-screwdriver.svg": "mO84",
	"./glyph/si-glyph-wrench.svg": "Fu34",
	"./glyph/si-glyph-yen.svg": "Lp/P",
	"./glyph/si-glyph-ying-yang.svg": "yPbz",
	"./glyph/si-glyph-zip.svg": "7k58",
	"./glyph/si-glyph-zoom-in.svg": "IDjT",
	"./glyph/si-glyph-zoom-out.svg": "xTZ+",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./marketplace.svg": "SqNd",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./qrcode.svg": "HQ2j",
	"./qrcode2.svg": "IKKE",
	"./raca/raca.svg": "o+mM",
	"./role.svg": "cqqK",
	"./setting.svg": "Kttn",
	"./setting2.svg": "Ea17",
	"./setting3.svg": "UTM7",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./user2.svg": "AxbE",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eZ11";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg \.svg$
// module id = eZ11
// module chunks = 62